import { Children, cloneElement, isValidElement, useEffect, useRef, useState } from 'react';
import './Expandable2.css';

/**
  * @param {ReactNode} summary - The summary content displayed when the section is collapsed 
  * @param {ReactNode} children - The content displayed when the section is expanded
  * @param {string} name - The name attribute for the <details> element. This attribute ensures only one element is opened at a time within a group of details elements sharing the same name.
*/
export const Expandable2 = ({ summary, name, children: Children, id, onOpenChange, stickySummary }) => {

  const [open, setOpen] = useState(false);


  const keyupHandler = (e) => {
    switch (e.code) {
      case 'ArrowUp':
        e.currentTarget.previousElementSibling?.querySelector(':scope>details')?.querySelector('summary')?.focus();
        break;
      case 'Tab':
        break;
      // e.shiftKey ?
      //   e.currentTarget.previousElementSibling?.querySelector(':scope>details')?.querySelector('summary')?.focus()
      //   :
      //   e.currentTarget.nextElementSibling?.querySelector(':scope>details')?.querySelector('summary')?.focus();
      // break;
      case 'ArrowDown':
        e.currentTarget.nextElementSibling?.querySelector(':scope>details')?.querySelector('summary')?.focus();
        break;
      default:
    }
  }

  const [hideDetails, setHideDetails] = useState(true);
  const preventHide = useRef(false);

  const openChange = (opened) => {
    setOpen(opened);
  }

  // useEffect(() => {
  //   if (!open) {
  //     if (!preventHide.current) {
  //       setTimeout(() => {
  //         setHideDetails(true);
  //         preventHide.current = true;
  //       }, 50)
  //     }
  //   } else {
  //     preventHide.current = false;
  //     setHideDetails(false);
  //   }
  // }, [open]);

  useEffect(()=>{
    onOpenChange?.(!hideDetails);
  },[hideDetails])

  useEffect(() => {
    if (!open) {
      setHideDetails(true);
    } else {
      setHideDetails(false);
    }
  }, [open])

  return (<div className={`expandable-component ${stickySummary ? 'stickysummary':''}`} onKeyUp={keyupHandler} id={id}>
    {Boolean(summary) && <details  name={name} onToggle={(e) => openChange(e.target.open)}>
      <summary>
        {summary}
      </summary>
    </details>}
    <div className='expandable-details' style={ !open ? {visibility: 'hidden'} :{}}>
      {isValidElement(Children) ? cloneElement(Children, { open: open }) : Children}
    </div>
  </div>);
}

